import pptxgen from "pptxgenjs";

const pptxTotalHeight = 5.625; // in inches, for a 16:9 slide

export const convertVerticalDimToHtmlPercent = (yIn?: pptxgen.Coord) => {
  if (yIn === undefined) return undefined;
  return ((yIn as number) / pptxTotalHeight) * 100;
};

